<template>
  <div>
    <div class="bg">
      <el-radio-group @change="changeModule" v-model="searchCondition.moduleId" size="small">
        <el-radio-button v-for="(v,i) in moduleList" :key="i" :label="v.value">{{ v.label }}</el-radio-button>
      </el-radio-group>
    </div>
    <hm-content class="mt10">
      <div class="flex flex-between">
        <el-button type="primary" size="small" @click="addFunc"
        >添加功能
        </el-button>
        <div class="flex flex-end">
          <el-button type="primary" size="small" class="ml20" @click="openCache"
          >缓存管理
          </el-button>
        </div>
      </div>
      <el-table
          stripe
          border
          ref="table"
          :data="list"
          class="mt20"
          style="width: 100%"
          id="table"
          size="small"
      >
        <el-table-column
            type="index"
            label="序号"
            :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="funcName"
            label="功能名称"
        >
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="funcCode"
            label="唯一标识"
        >
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="popoverName"
            label="灰度模式开关(关闭后所有用户展示应用)"
        >
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.enabledState"
                active-color="#2FC348"
                inactive-color="#DDDDDD"
                @change="editEnabledState(scope.row)"
                active-value="yes"
                inactive-value="no">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            header-align="center"
            align="center"
            width="200px"
        >
          <template slot-scope="scope">
            <el-button size="small" type="text"
            >版本管理</el-button
            >
            <el-button size="small" type="text" @click="whiteConfig(scope.row)"
            >白名单配置</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
        ></el-pagination>
      </div>

      <!--添加功能弹窗-->
      <el-dialog title="添加功能" :visible.sync="dialogFormAddVisible">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
          <el-form-item label="功能名称" prop="funcName">
            <el-input v-model="ruleForm.funcName" size="small" placeholder="请输入功能名称"></el-input>
          </el-form-item>
          <el-form-item label="功能标识" prop="funcCode">
            <el-input v-model="ruleForm.funcCode" size="small"  placeholder="请输入功能标识"></el-input>
          </el-form-item>
          <el-form-item label="功能状态" prop="enabledState">
            <el-switch
                v-model="ruleForm.enabledState"
                active-color="#2FC348"
                inactive-color="#DDDDDD"
                active-value="yes"
                inactive-value="no">
            </el-switch>
          </el-form-item>
          <el-form-item label="活动备注" prop="funcRemark">
            <el-input type="textarea" v-model="ruleForm.funcRemark"  placeholder="请输入活动备注"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer flex flex-center">
          <el-button
              type="primary"
              size="small"
              @click="submitForm('ruleForm', 'funcInfo')"
          >确 定</el-button
          >
          <el-button
              @click="dialogFormAddVisible = false"
              size="small"
          >取 消</el-button
          >
        </div>
      </el-dialog>


      <!--白名单配置-->
      <el-drawer
          custom-class="hm-drawer"
          title="白名单配置"
          :visible.sync="whiteConfigDrawer"
          :direction="direction">
        <div class="drawer-bg">
          <div class="flex item-center">
            <span>
              选择模板:
            </span>
            <el-select v-model="whiteConfigItem.funcVersionId" :disabled="whiteConfigVersionList.length <= 1" size="small" class="ml10" filterable placeholder="请选择">
              <el-option
                  v-for="(item, i) in whiteConfigVersionList"
                  :key="i"
                  :label="item.verionName"
                  :value="item.funcVersionId">
              </el-option>
            </el-select>
          </div>
          <div class="flex item-center mt20">
            <el-input placeholder="请输入内容" v-model="whiteSearchCondition.keyWord" size="small" class="mr20">
              <el-select v-model="whiteSearchCondition.queryType" slot="prepend" style="width: 100px" placeholder="请选择">
                <el-option :label="v.label" :value="v.value" v-for="(v, i) in whiteQueryTypeList" :key="i"></el-option>
              </el-select>
            </el-input>
            <div>
              <el-button type="primary" class="ml10" size="small" @click="searchWhiteConfigTree"
              >查询</el-button
              >
            </div>
          </div>
          <div class="mt40">
            <div class="tree-title">选择可使用的用户</div>
            <div v-if="searchCondition.moduleId!='e9b0478a-2ee1-11ef-9096-08c0ebd4dda2'">
              <div style="height: 600px" v-if="whiteConfigDrawer && !isSearch">
                <el-scrollbar
                    style="height:100%" class="page-component__scroll"
                >
                  <el-tree
                      :props="props"
                      :load="loadNode"
                      ref="whiteConfigTree"
                      class="mt20"
                      node-key="value"
                      :key="'whiteConfigTree'"
                      lazy
                      @check-change="handleCheckChange('whiteConfigTree')"
                      v-if="whiteConfigDrawer && !isSearch"
                      show-checkbox
                  >
                  </el-tree>
                </el-scrollbar>
              </div>
              <div style="height: 600px" v-else>
                <el-scrollbar
                    style="height:100%" class="page-component__scroll"
                >
                  <el-tree
                      :data="searchTree"
                      show-checkbox
                      ref="whiteConfigSearchTree"
                      default-expand-all
                      highlight-current
                      node-key="value"
                      class="mt20"
                      @check-change="handleCheckChange('whiteConfigSearchTree')"
                      v-if="whiteConfigDrawer && isSearch"
                      :props="defaultProps">
                  </el-tree>
                </el-scrollbar>
              </div>
            </div>
            <div v-else>
              <div style="height: 600px" v-if="whiteConfigDrawer && !isSearch">
                <el-scrollbar
                    style="height:100%" class="page-component__scroll"
                >
                  <el-tree
                      :props="props"
                      :load="loadNode1"
                      ref="whiteConfigTree1"
                      class="mt20"
                      node-key="value"
                      :key="'whiteConfigTree1'"
                      lazy
                      @check-change="handleCheckChange1('whiteConfigTree1')"
                      v-if="whiteConfigDrawer && !isSearch"
                      show-checkbox
                  >
                  </el-tree>
                </el-scrollbar>
              </div>
              <div style="height: 600px" v-else>
                <el-scrollbar
                    style="height:100%" class="page-component__scroll"
                >
                  <el-tree
                      :data="searchTree"
                      show-checkbox
                      :key="'whiteConfigSearchTree1'"
                      ref="whiteConfigSearchTree1"
                      default-expand-all
                      node-key="centerId"
                      class="mt20"
                      @check-change="handleCheckChange1('whiteConfigSearchTree1')"
                      v-if="whiteConfigDrawer && isSearch"
                      :props="defaultProps1">
                  </el-tree>
                </el-scrollbar>
              </div>
            </div>
          </div>
          <div class="flex flex-end item-center mt20">
            <el-button
                type="primary"
                size="small"
                v-if="searchCondition.moduleId!='e9b0478a-2ee1-11ef-9096-08c0ebd4dda2'"
                @click="saveWhiteConfig"
            >确 定</el-button
            >
             <el-button
                type="primary"
                size="small"
                v-else
                @click="saveWhiteConfig1"
            >确 定</el-button
            >
          </div>
        </div>
      </el-drawer>

      <el-dialog title="缓存管理" :visible.sync="dialogVisibleCache">
        <div class="flex">
          <el-button type="primary" size="small" class="ml20" @click="queryCacheCount"
          >查询缓存数量
          </el-button>
          <el-button type="primary" size="small" class="ml20" @click="clearCache"
          >清理缓存
          </el-button>
          <el-button type="primary" size="small" class="ml20" @click="queryCacheSettings"
          >查询缓存配置
          </el-button>
          <el-button type="primary" size="small" class="ml20" @click="updateCacheSettings"
          >更新缓存配置
          </el-button>
        </div>
        <div v-if="queryCacheCountResult.state">
          <div class="mt10">
            功能缓存数量:{{ queryCacheCountResult.funcConfigKeysCount }}
            <span v-if="clearCacheResult.state">(清除缓存前{{clearCacheResult.funcConfigKeysCount}}==>清除缓存后{{clearCacheResult.funcConfigKeysAfter}})</span>            
          </div>
          <div class="mt10">商城缓存数量:{{ queryCacheCountResult.storeConfigKeysCount }}<span v-if="clearCacheResult.state">(清除缓存前{{clearCacheResult.storeConfigKeysCount}}==>清除缓存后{{clearCacheResult.storeConfigKeysAfter}})</span></div>
          <div class="mt10">用户缓存数量:{{ queryCacheCountResult.customerConfigKeysCount }}<span v-if="clearCacheResult.state">(清除缓存前{{clearCacheResult.customerConfigKeysCount}}==>清除缓存后{{clearCacheResult.customerConfigKeysAfter}})</span></div>
        </div>
        <div v-if="queryCacheSettingsResult.state">
          <div class="mt10">
            功能缓存配置时间:<el-input v-model="queryCacheSettingsResult.verifyHasMpsFuncConfigFuncCacheMinutes" size="small" placeholder="请输入功能缓存配置时间"></el-input>分钟
          </div>
          <div class="mt10">
            商城缓存配置时间:<el-input v-model="queryCacheSettingsResult.verifyHasMpsFuncConfigStoreCacheMinutes" size="small" placeholder="请输入商城缓存配置时间"></el-input>分钟
          </div>
          <div class="mt10">
            用户缓存配置时间:<el-input v-model="queryCacheSettingsResult.verifyHasMpsFuncConfigCustomerCacheMinutes" size="small" placeholder="请输入用户缓存配置时间"></el-input>分钟
          </div>
        </div>  
      </el-dialog>  
    </hm-content>
  </div>

</template>

<script>
export default {
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {
        moduleId: "71c48ede-61bd-11ea-9991-506b4bf045f0"
      },
      moduleList: [
        {
          label: "商城",
          value: "71c48ede-61bd-11ea-9991-506b4bf045f0",
          moduleCode: "store"
        },
        {
          label: "红包",
          value: "39b276d0-61bd-11ea-9b00-b8599f36fcd8",
          moduleCode: "supplier"
        },
        {
          label: "导购助手",
          value: "a08b0bcf-6424-11ea-9991-506b4bf045f0",
          moduleCode: "guider"
        },
        {
          label: "禾销供应商",
          value: "e9b0478a-2ee1-11ef-9096-08c0ebd4dda2",
          moduleCode: "hexiao"
        }
      ],
      dialogFormAddVisible: false,
      ruleForm: {
        funcName: "",
        funcCode: "",
        enabledState: "yes",
        funcRemark: ""
      },
      rules: {
        funcName: {
          required: true,
          message: "请填写功能名称",
          trigger: "blur"
        },
        funcCode: {
          required: true,
          message: "请填写功能标识",
          trigger: "blur"
        },
        enabledState: {
          required: true,
          message: "请选择功能状态",
          trigger: "change"
        },
      },
      whiteConfigDrawer: false,
      direction: "rtl",
      whiteConfigVersionList: [],
      whiteConfigItem: {
        funcVersionId: ""
      },
      whiteSearchCondition: {
        queryType: "store"
      },
      whiteQueryTypeList: [
        {
          label: "商户",
          value: "store"
        },
        {
          label: "门店",
          value: "shop"
        },
        {
          label: "用户",
          value: "center"
        }
      ],
      props: {
        value: "value",
        label: "label",
        children: "children",
      },
      currentModule: {},
      isSearch: false,
      row: {},
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      defaultProps1: {
        children: 'whiteConfigList',
        label: 'label',
      },
      searchTree: [],
      checkNodes: [],
      checkedCenterList: [],
      checkedProvinceList: [],
      checkedShopList: [],
      checkedStoreList: [],
      excludeCenterIdList: [],
      dialogVisibleCache: false,
      queryCacheCountResult:{
        funcConfigKeysCount: 0,
        storeConfigKeysCount: 0,
        customerConfigKeysCount: 0,
        state: false,
      },
      clearCacheResult:{
        state: false,
      },
      queryCacheSettingsResult:{
        state: false,
      },
      updateCacheSettingsResult:{
        state: false,
      },
      
      checkedSupplierList:[],
      checkedEmployeeList:[]
    };
  },
  created() {
    this.currentModule = this.moduleList[0];
  },
  mounted() {
    this.queryList();
  },
  methods: {
    async defultCheckNodes() {
      let params = {
        funcId: this.row.funcId,
        funcVersionId: this.whiteConfigItem.funcVersionId,
        moduleCode: this.currentModule.moduleCode
      };
      const { result } = await this.$store.dispatch("queryCheckedMpsFuncStoreCustomerConfig", params);
      console.log("result", result);
      const { centerList, provinceList, shopList, storeList, supplierList
,employeeList } = result;
      if(centerList){
      this.checkedCenterList = centerList;
      this.excludeCenterIdList = centerList;
      }
      if(provinceList){
      this.checkedProvinceList = provinceList;
      }
      if(storeList){
      this.checkedStoreList = provinceList.concat(storeList);
      this.checkedShopList = provinceList.concat(storeList).concat(shopList);
      }
      if(supplierList){
        this.checkedSupplierList = supplierList
      }
      if(employeeList){
        this.checkedEmployeeList = employeeList
      }
    },
    setHalfCheckedNodes(key, treeName) {
      const node = this.$refs[treeName].getNode(key);
      console.log("node", node);
      console.log("treeName", this.$refs[treeName]);
      if (node) { // 此处应判断当前节点的checked属性是否为true，是则不必半选
        node.indeterminate = true
      }
    },
    setCheckedNodes(key, treeName) {
      console.log('-----------------')
      console.log(key)
      console.log(treeName)
      this.$refs[treeName].setChecked(key, true);
      this.handleCheckChange(treeName)
    },
    async saveWhiteConfig() {
      console.log(1111)
      if(!this.isSearch){
       this.checkNodes = this.$refs['whiteConfigTree'].getCheckedNodes();
      }else{
        this.checkNodes = this.$refs['whiteConfigSearchTree'].getCheckedNodes();
      }
      let arr = this.checkNodes;
      console.log(this.checkNodes)
      let list = arr.filter(v => v.type == "center");
      let params = {
        moduleId: this.currentModule.value,
        funcId: this.row.funcId,
        funcVersionId: this.whiteConfigItem.funcVersionId,
        customerConfigList: list,
        excludeCenterIdList: this.excludeCenterIdList,
      };
      await this.$store.dispatch("saveMpsFuncWhiteConfig", params);
      this.$message({
        message: "操作成功",
        type: "success"
      });
      this.whiteConfigDrawer = false;
    },
    handleCheckChange(treeName) {
     this.checkNodes = this.$refs[treeName].getCheckedNodes();
     console.log(this.checkNodes)
     console.log('--------------')
     console.log("this.checkNodes:",this.checkNodes);
     this.checkNodes.forEach(v=>{
      this.excludeCenterIdList.forEach((o,index)=>{
        if(v.centerId === o){
          this.excludeCenterIdList.splice(index, 1)
        }
      })
     })
     console.log("this.excludeCenterIdList:",this.excludeCenterIdList);
    },
    loadNode(node, resolve) {
      // 一级节点处理(省份数据)
      if (node.level === 0) {
        this.whiteConfigProvince(resolve);
      }
      // 二级节点处理(商户数据)
      if (node.level === 1) {
        console.log(1)
        // 注意！把resolve传到你自己的异步中去
        this.whiteConfigStore(node, resolve);
      }
      //三级节点处理(门店)
      if (node.level === 2) {
        console.log(2)
        // 注意！把resolve传到你自己的异步中去
        this.whiteConfigShop(node, resolve);
      }
      //四级节点处理(导购)
      if (node.level === 3) {
        // 注意！把resolve传到你自己的异步中去
        this.whiteConfigGuider(node, resolve);
      }
      //其余节点处理（直接返回空）
      if (node.level > 3) {
        resolve([]);
      }
    },

    // 首次加载一级节点数据函数
    whiteConfigProvince(resolve) {
      this.$store
          .dispatch("queryMpsFuncWhiteConfigProvince", {
            moduleCode: this.currentModule.moduleCode
          })
          .then(res => {
            const data = res.result;
            data.forEach(v => {
              v.label = v.storeProvinceName;
              v.value = v.storeProvince;
              v.type = "province";
              if (!v.label) {
                v.label = "其他地区";
              }
              if (!v.value) {
                v.value = "other";
              }
            });

            resolve(data);
          })
          .catch(err => {
            throw new Error(err);
          }).finally(() => {
            if (this.checkedProvinceList && this.checkedProvinceList.length > 0) {
              this.checkedProvinceList.forEach(v =>{
                if (v.flag) {
                  this.setCheckedNodes(v.value, 'whiteConfigTree');
                } else {
                  this.setHalfCheckedNodes(v.value, 'whiteConfigTree');
                }
              })
            }
          });
    },
    // 异步加载二级子节点数据函数
    whiteConfigStore(node, resolve) {
      this.$store
          .dispatch("queryMpsFuncWhiteConfigStore", {
            storeProvince: node.data.value,
            moduleCode: this.currentModule.moduleCode
          })
          .then(res => {
            const data = res.result;
            data.forEach(v => {
              v.value = v.storeCode;
              v.label = v.storeName;
              v.type = "store";
            });
            resolve(data);
          })
          .catch(err => {
            throw new Error(err);
          }).finally(() => {
        if (this.checkedStoreList && this.checkedStoreList.length > 0) {
          this.checkedStoreList.forEach(v =>{
            if (v.flag) {
              this.setCheckedNodes(v.value, 'whiteConfigTree');
            } else {
              this.setHalfCheckedNodes(v.value, 'whiteConfigTree');
            }
          })
        }
      });
    },
    // 异步加载三级子节点数据函数
    whiteConfigShop(node, resolve) {
      this.$store
          .dispatch("queryMpsFuncWhiteConfigShop", {
            storeCode: node.data.value,
            moduleCode: this.currentModule.moduleCode
          })
          .then(res => {
            const data = res.result;
            data.forEach(v => {
              v.value = v.shopId;
              v.label = v.shopName;
              v.type = "shop";
            });
            resolve(data);
          })
          .catch(err => {
            throw new Error(err);
          }).finally(() => {
        if (this.checkedShopList && this.checkedShopList.length > 0) {
          this.checkedShopList.forEach(v =>{
            if (v.flag) {
              this.setCheckedNodes(v.value, 'whiteConfigTree');
            } else {
              this.setHalfCheckedNodes(v.value, 'whiteConfigTree');
            }
          })
        }
      });
    },
    // 异步加载四级子节点数据函数
    whiteConfigGuider(node, resolve) {
      this.$store
          .dispatch("queryMpsFuncWhiteConfigGuider", {
            shopId: node.data.value,
            moduleCode: this.currentModule.moduleCode
          })
          .then(res => {
            const data = res.result;
            data.forEach(v => {
              v.value = v.centerId;
              v.label = v.centerName;
              v.type = "center";
            });
            resolve(data);
          })
          .catch(err => {
            throw new Error(err);
          }).finally(() => {
            if (this.checkedCenterList && this.checkedCenterList.length > 0) {
              this.checkedCenterList.forEach(v => {
                 console.log(1111111)
                this.setCheckedNodes(v, 'whiteConfigTree');
              })
            }
      });
    },
    async searchWhiteConfigTree() {
    console.log(this.currentModule)
      if (!this.whiteSearchCondition.keyWord) {
        this.isSearch = false;
        return;
      }
      this.isSearch = true;
      let params = {
        moduleCode: this.currentModule.moduleCode
      }
      const searchCondition = JSON.parse(JSON.stringify(this.whiteSearchCondition));
      Object.assign(params, searchCondition);
      // if(this.currentModule.value=='e9b0478a-2ee1-11ef-9096-08c0ebd4dda2'){
      // }
       const { result } = await this.$store.dispatch("searchWhiteConfigTree", params);
      this.searchTree = result;
      console.log('-----------')
      console.log(this.checkedCenterList)
      if(this.checkedCenterList.length>0&&this.searchCondition.moduleId!='e9b0478a-2ee1-11ef-9096-08c0ebd4dda2'){
      this.$refs.whiteConfigSearchTree.setCheckedKeys(this.checkedCenterList,true)
      }
      if(this.checkedEmployeeList.length>0&&this.searchCondition.moduleId=='e9b0478a-2ee1-11ef-9096-08c0ebd4dda2'){
        console.log(this.checkedEmployeeList)
      this.$refs.whiteConfigSearchTree1.setCheckedKeys(this.checkedEmployeeList,true)
      }
    },
    async whiteConfig(row) {
      this.row = row;
      let params = {
        pageNo: 1,
        pageSize: 9999,
        funcId: row.funcId
      }
      const { result } = await this.$store.dispatch("queryMpsFuncVersionPageList", params);
      console.log("result", result);
      if (!result.records || result.records.length < 1) {
        this.$message.error("请先设置版本信息");
        return;
      }
      this.whiteConfigVersionList = result.records;
      this.whiteConfigItem.funcVersionId = result.records[0].funcVersionId;
      this.whiteConfigDrawer = true;
      this.defultCheckNodes();
        setTimeout(() => {
          this.searchWhiteConfigTree()
        }, 500);
    },
    submitForm(formName, type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (type == "funcInfo") {
            let params = JSON.parse(JSON.stringify(this.ruleForm));
            params.moduleId = this.searchCondition.moduleId;
            this.$store.dispatch("addMpsFuncInfo", params).then(res => {
              console.log("res", res);
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success"
                });
                this.dialogFormAddVisible = false
                this.queryList();
              }
            })
          } else if (type == "funcVersion") {

          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    addFunc() {
      this.dialogFormAddVisible = true;
      this.$nextTick(() => {
        this.resetForm("ruleForm");
      })
    },
    changeModule() {
      this.isSearch  = false
      // this.whiteSearchCondition.keyWord = ''
      this.moduleList.forEach(v => {
        if (v.value == this.searchCondition.moduleId) {
          this.currentModule = v;
        }
      });
      if(this.searchCondition.moduleId=='e9b0478a-2ee1-11ef-9096-08c0ebd4dda2'){
        this.whiteQueryTypeList=[
          {
            label: "供应商",
            value: "supplier"
          },
          {
            label: "职员",
            value: "employee"
          }
        ]
        this.whiteSearchCondition.queryType = 'supplier'
      }else{
        this.whiteQueryTypeList=[
          {
            label: "商户",
            value: "store"
          },
          {
            label: "门店",
            value: "shop"
          },
          {
            label: "用户",
            value: "center"
          }
        ]
        this.whiteSearchCondition.queryType = 'store'
      }
      console.log("this.currentModule ", this.currentModule )
      this.currentPage = 1;
      this.queryList();
    },
    async editEnabledState(item) {
      await this.$store.dispatch("editMpsFuncEnabledState", item);
      this.$message({
        message: " 操作成功",
        type: "success"
      });
      this.queryList();
    },
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch("queryMpsFuncInfoPageList", params);
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    //查询缓存数量
    async queryCacheCount(){
      const { result } = await this.$store.dispatch("queryCacheCount");
      this.queryCacheCountResult = result;
      this.queryCacheCountResult.state = true;
      this.queryCacheSettingsResult.state = false;
    },
    //清理缓存
    async clearCache(){
      const { result } = await this.$store.dispatch("clearCache");
      this.clearCacheResult = result;
      this.clearCacheResult.state = true;
      this.queryCacheCount();
    },
    //查询缓存配置
    async queryCacheSettings(){
      const { result } = await this.$store.dispatch("queryCacheSettings");
      this.queryCacheSettingsResult = result;
      this.queryCacheCountResult.state = false;
      this.queryCacheSettingsResult.state = true;
    },
    //更新缓存配置
    async updateCacheSettings(){
      if(!this.queryCacheSettingsResult.state){
        this.queryCacheSettings();
        return;
      }
      let params = {
        verifyHasMpsFuncConfigFuncCacheMinutes: this.queryCacheSettingsResult.verifyHasMpsFuncConfigFuncCacheMinutes,
        verifyHasMpsFuncConfigStoreCacheMinutes: this.queryCacheSettingsResult.verifyHasMpsFuncConfigStoreCacheMinutes,
        verifyHasMpsFuncConfigCustomerCacheMinutes: this.queryCacheSettingsResult.verifyHasMpsFuncConfigCustomerCacheMinutes,
      }
      const { code } = await this.$store.dispatch("updateCacheSettings",params);
      if( code === '0'){
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.queryCacheSettings();
      }
    },
    openCache(){
      this.dialogVisibleCache = true;
    },

    loadNode1(node, resolve) {
      console.log(111111)
      // 一级节点处理(省份数据)
      if (node.level === 0) {
        this.querySupplierBasicList(resolve);
      }
      // 二级节点处理(商户数据)
      if (node.level === 1) {
         console.log(1)
        // 注意！把resolve传到你自己的异步中去
        this.queryEmployeeList(node, resolve);
      }
      //其余节点处理（直接返回空）
      if (node.level > 1) {
        resolve([]);
      }
    },
    // 首次加载一级节点数据函数
   querySupplierBasicList(resolve){
      let params = {
        pageSize: 9999,
        pageNo: 1,
        keyWords: ''
      };
      this.$store.dispatch(
        "querySupplierBasicList",
        params
      ).then(res => {
            const data = res.result.records;
            console.log(data)
            data.forEach(v => {
              v.label = v.storeName;
              v.value = v.storeCode;
              v.type = "supplier";
            });
            resolve(data);
          })
          .catch(err => {
            throw new Error(err);
          }).finally(() => {
            if (this.checkedSupplierList && this.checkedSupplierList.length > 0) {
              this.checkedSupplierList.forEach(v =>{
                if (v.flag) {
                  console.log(1111111)
                  this.setCheckedNodes(v.value, 'whiteConfigTree1');
                } else {
                  console.log(1111111)
                  this.setHalfCheckedNodes(v.value, 'whiteConfigTree1');
                }
              })
            }
          });
    },
        // 异步加载二级子节点数据函数
    queryEmployeeList(node, resolve) {
      this.$store.dispatch("queryEmployeeList", {
          pageNo: 1,
          pageSize: 99999,
          queryKey: '',
          loginType: "supplier",
          storeCode: node.data.value
        }).then(res => {
            const data = res.result.records;
            data.forEach(v => {
              v.value = v.employeeId;
              v.label = v.realname;
              v.type = "employee";
            });
            resolve(data);
          })
          .catch(err => {
            throw new Error(err);
          }).finally(() => {
        if (this.checkedEmployeeList && this.checkedEmployeeList.length > 0) {
           this.checkedEmployeeList.forEach(v => {
                this.setCheckedNodes(v, 'whiteConfigTree1');
                console.log(111111)
              })
        }
      });
    },
     handleCheckChange1(treeName) {
     this.checkNodes = this.$refs[treeName].getCheckedNodes();
     console.log(this.checkNodes)
     console.log('--------------')
     console.log("this.checkNodes:",this.checkNodes);
     this.checkNodes.forEach(v=>{
      this.excludeCenterIdList.forEach((o,index)=>{
        if(v.employeeId === o){
          this.excludeCenterIdList.splice(index, 1)
        }
      })
     })
     console.log("this.excludeCenterIdList:",this.excludeCenterIdList);
    },
    async saveWhiteConfig1() {
      if(!this.isSearch){
       this.checkNodes = this.$refs['whiteConfigTree1'].getCheckedNodes();
      }else{
        this.checkNodes = this.$refs['whiteConfigSearchTree1'].getCheckedNodes();
      }
      let arr = this.checkNodes;
      console.log(arr)
      console.log('-----------')
      if(arr.length>0&&!this.isSearch){
        arr.forEach((item)=>{
          console.log(11111)
          item.centerId = item.employeeId
          item.centerName = item.realname
          item.centerMobile = item.phone
        })
      }else if(arr.length>0&&this.isSearch){
          arr = arr.filter(v => v.type == "center");
      }
      let params = {
        moduleId: this.currentModule.value,
        funcId: this.row.funcId,
        funcVersionId: this.whiteConfigItem.funcVersionId,
        customerConfigList: arr,
        excludeCenterIdList: this.excludeCenterIdList,
      };
      await this.$store.dispatch("saveMpsFuncWhiteConfig", params);
      this.$message({
        message: "操作成功",
        type: "success"
      });
      this.whiteConfigDrawer = false;
    },
  },
};
</script>

<style scoped lang="scss">
.bg {
  padding: 20px;
  background-color: #fff;
}
.drawer-bg {
  padding: 20px;
}
.tree-title {
  font-size: 14px;
  color: #222222;
}
</style>
